import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Stack } from "@mui/material";
import AllAssignments from "./AllAssignments";
import { getassignments } from "../services/assignments";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import NoClasseEnrolledScreen from "../NoClassEnrolledScreen";

const AssignmentFilters = () => {
  const userId = localStorage.getItem("userId");
  const [active, setActive] = useState("all");
  const [filterdData, setFilteredData] = useState([]);
  const [assignmentsData, setAssignemtsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const filters = [
    { label: "All Assignment", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Submitted", value: "submitted" },
    { label: "Graded", value: "graded" },
    { label: "Rejected", value: "rejected" },
  ];

  //   const assignmentsData = [
  //   {
  //     id: 1,
  //     title: "Research Paper on Machine Learning",
  //     subject: "IELTS",
  //     module: "Listening",
  //     trainer: "Simranjeet",
  //     instructions:
  //       "Complete the worksheet covering thesis, future scope, conclusion.",
  //     totalMarks: 100,
  //     obtainedMarks: null,
  //     status: "pending", // pending | submitted | graded
  //     dueDate: "2025-10-15",
  //     submittedDate: null,
  //     feedback: null,
  //     attachment: null,
  //   },
  //   {
  //     id: 2,
  //     title: "Calculus Problem Set #3",
  //     subject: "IELTS",
  //     module: "Listening",
  //     trainer: "Simranjeet",
  //     instructions:
  //       "Solve the following differential equations and optimization problems. Show all your work.",
  //     totalMarks: 100,
  //     obtainedMarks: null,
  //     status: "submitted",
  //     dueDate: "2025-10-15",
  //     submittedDate: "2025-10-20",
  //     feedback: null,
  //     attachment: {
  //       fileName: "calculus_solution.pdf",
  //       fileUrl: "/uploads/calculus_solution.pdf",
  //       fileSize: "2.3 MB",
  //     },
  //   },
  //   {
  //     id: 3,
  //     title: "Web Development Set #3",
  //     subject: "IELTS",
  //     module: "Listening",
  //     trainer: "Simranjeet",
  //     instructions: "Create a responsive landing page using HTML & CSS.",
  //     totalMarks: 100,
  //     obtainedMarks: 80,
  //     status: "graded",
  //     dueDate: "2025-10-15",
  //     submittedDate: "2025-10-20",
  //     feedback: "Good work. Keep practicing.",
  //     attachment: {
  //       fileName: "web_dev_assignment.zip",
  //       fileUrl: "/uploads/web_dev_assignment.zip",
  //       fileSize: "5.1 MB",
  //     },
  //   },
  // ];

  const handleFetchAssignments = async () => {
    setIsLoading(true);
    try {
      const response = await getassignments(userId);
      console.log("response", response);
      setAssignemtsData(response?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching assignments:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleFetchAssignments();
  }, []);

  useEffect(() => {
    if (active === "all") {
      setFilteredData(assignmentsData);
    } else if (active === "pending") {
      setFilteredData(
        assignmentsData?.filter((assignment) => assignment.status === "Pending"),
      );
    } else if (active === "submitted") {
      setFilteredData(
        assignmentsData?.filter(
          (assignment) => assignment.status === "Submitted",
        ),
      );
    } else if (active === "graded") {
      setFilteredData(
        assignmentsData.filter((assignment) => assignment.status === "Graded"),
      );
    } else if (active === "rejected") {
      setFilteredData(
        assignmentsData?.filter(
          (assignment) => assignment.status === "Rejected",
        ),
      );
    }
  }, [active, assignmentsData]);

  const assignmentStatusContent = {
    all: {
      text: "No Assignments Available",
      subText:
        "You don’t have any assignments available at the moment. Please check back later.",
    },
    pending: {
      text: "No Pending Assignments Available",
      subText:
        "You don’t have any pending assignments available at the moment. Please check back later.",
    },
    submitted: {
      text: "No Submitted Assignments Available",
      subText:
        "You don’t have any submitted assignments available at the moment. Please check back later.",
    },
    graded: {
      text: "No Graded Assignments Available",
      subText:
        "You don’t have any graded assignments available at the moment. Please check back later.",
    },
    rejected: {
      text: "No Rejected Assignments Available",
      subText:
        "You don’t have any rejected assignments available at the moment. Please check back later.",
    },
  };

  const content =
    assignmentStatusContent[active] || assignmentStatusContent["all"];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Stack direction="row" spacing={2}>
          {filters.map((item) => (
            <Button
              key={item.value}
              onClick={() => setActive(item.value)}
              variant={active === item.value ? "contained" : "outlined"}
              sx={{
                textTransform: "none",
                // fontFamily: "Inter",
                fontWeight: 500,
                borderRadius: "8px",
                px: 3,
                height: "33px",
                fontSize: "14px",

                ...(active === item.value
                  ? {
                      backgroundColor: "#572575",
                      color: "#fff",
                      boxShadow: "0px 4px 12px rgba(106,27,154,0.25)",
                      "&:hover": {
                        backgroundColor: "#572575",
                      },
                    }
                  : {
                      borderColor: "#572575",
                      color: "#773D9A",
                      "&:hover": {
                        borderColor: "#6A1B9A",
                        backgroundColor: "rgba(106,27,154,0.05)",
                      },
                    }),
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>
      </Grid>

      {isLoading ? (
        <Grid item xs={12}>
          <Loader text="Loading Assignments..." height="60vh" />{" "}
        </Grid>
      ) : !isLoading && filterdData?.length === 0 ? (
        <Grid item xs={12}>
          <NoClasseEnrolledScreen
            text={content.text}
            subText={content.subText}
            showButton={false}
          />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <AllAssignments filterdData={filterdData} setFilteredData={setFilteredData} isLoading={isLoading} />
        </Grid>
      )}
    </Grid>
  );
};

export default AssignmentFilters;
